// 法律文档正文（简体中文）。由 iOS ios/XingRoute/Features/Profile/LegalDocuments.swift 同步派生，
// 二者应保持一致（当前为各自维护，改动请同步）。

export interface LegalDocument {
  title: string
  intro: string[]
  sections: { heading: string; body: string[] }[]
}

export const WEBSITE_ICP_FILING_NUMBER = '苏ICP备2026038534号-1'
export const IOS_APP_FILING_NUMBER = '苏ICP备2026038534号-2A'

export const legalDocuments: { terms: LegalDocument; privacy: LegalDocument } = {
  terms: {
    title: '寻径 XingRoute 服务条款',
    intro: [
      '本《服务条款》（以下简称「本条款」）是你与寻径（XingRoute，以下简称「本应用」或「寻径」）运营者归迹团队（以下简称「我们」）之间就使用本应用及相关服务所订立的协议。',
      '生效日期：2026-08-24',
      '寻径是一款面向非铺装路面户外运动（徒步、越野跑）的轨迹记录与线路平台，主要面向中国大陆用户提供服务。请你在使用本应用前认真阅读本条款，特别是以粗体或下划线标示的免责与责任限制条款。你下载、安装、登录或以其他方式使用本应用，即表示你已阅读、理解并同意接受本条款的全部内容。若你不同意本条款，请停止使用本应用。',
      '如你为未满 18 周岁的未成年人，请在监护人的陪同与同意下阅读本条款并使用本应用。',
    ],
    sections: [
      {
        heading: '一、定义与服务说明',
        body: [
          '· 本应用：指寻径 iOS 应用程序及我们提供的相关网页端、后端服务与功能。',
          '· 用户内容：指你在使用本应用过程中创建、录制、导入、上传或发布的内容，包括但不限于运动轨迹、导入的轨迹文件、路线、途经点、文字备注、照片、视频、音频、昵称与头像等。',
          '本应用为你提供的核心功能包括：在地图上显示当前位置、记录运动轨迹、沿已选线路循迹导航、查看与收藏线路、将本地录制或导入的轨迹主动「提名/发布」为可分享的线路，以及可选的跨设备同步与分享功能。',
          '具体功能可能随版本迭代而调整。我们会以应用内更新、公告或其他合理方式告知重大变更。',
        ],
      },
      {
        heading: '二、服务资格与账号',
        body: [
          '· 你确认，在使用本应用的联网与账号功能时，你具备与所进行行为相适应的民事行为能力。',
          '· 在当前阶段，本应用通过 Apple 提供的「通过 Apple 登录」（Sign in with Apple）作为唯一的账号登录方式。登录时，我们仅获取并使用 Apple 返回的用户标识用于建立你的寻径账号，具体见《隐私政策》。',
          '· 你应妥善保管你的 Apple 账号及本设备，因你自身原因导致的账号被冒用、信息泄露或损失，由你自行承担；如发现账号存在安全问题，应及时采取措施并与我们联系。',
          '· 本应用支持通过扫描二维码授权网页端登录。你应确保仅对你本人发起的、可信的登录请求进行确认。',
        ],
      },
      {
        heading: '三、用户内容与授权许可',
        body: [
          '· 你在本应用中创建、录制或导入的运动轨迹、导入轨迹文件及笔记，在默认情况下仅保存在你的设备本地；只有在你主动开启 iCloud 同步、创建线路草稿或上传线路媒体时，相关内容才会离开本设备。初次提名或创建的云端线路一律为仅你及有权限审核人员可见的私人草稿，不会因上传而自动公开。',
          '· 你对用户内容保留原有权利。每次点击「提交发布审核」时，你须针对刚刚重新载入并显示版本标识的该次线路目录数据，单独确认你对标题、摘要/说明、活动与难度等元数据、轨迹几何及途经点拥有相应权利。',
          '· 完成上述确认即表示：你就该次线路目录数据授予归迹团队及寻径一项为运营公开线路目录所需的长期、免费、非独占许可，可在必要范围内存储、复制、处理、展示、分发及进行技术性加工。该许可不转移你的原有权利。',
          '· 上述许可不包括你独立上传的照片、视频或其他媒体；这些媒体不因线路发布而获得注销后保留授权，仍按一般用户内容和上传者权限管理。',
          '· 仅在线路经审核发布后，即使你随后注销账号，平台仍可依据该次许可保留并继续展示上述目录数据的去标识化公开副本；未发布私人草稿及独立上传媒体不属于该保留范围。',
          '· 你应确保对所上传或发布的用户内容拥有合法权利，且相关内容（包括你导入的第三方轨迹文件）不侵犯他人的知识产权、隐私权或其他合法权益，不违反法律法规及测绘、地理信息等相关规定。你对所上传内容的合法性、真实性独立承担责任。',
          '· 请注意：你公开设置的昵称（显示名）及头像会在个人主页、协作记录、网页登录确认页等场景对外展示。',
        ],
      },
      {
        heading: '四、可接受使用与禁止行为',
        body: [
          '在使用本应用时，你承诺不从事下列行为：',
          '· 上传、发布或传播违反法律法规、危害国家安全、涉及国家秘密、损害社会公共利益或违背公序良俗的内容；',
          '· 上传涉及国家规定的测绘管理、地理信息保密或军事禁区、涉密区域的敏感位置数据；',
          '· 未经授权上传、发布他人的运动轨迹、位置信息、肖像、个人信息或其他受法律保护的内容；',
          '· 发布虚假、误导性或可能诱导他人从事危险活动的线路信息；',
          '· 通过技术手段干扰、破坏本应用的正常运行，非法访问、抓取或过度请求服务器资源，或规避、破解安全与鉴权机制；',
          '· 侵犯我们或任何第三方的知识产权及其他合法权益，或从事其他违反本条款或法律法规的行为。',
          '如你违反上述约定，我们有权视情况采取删除内容、限制或终止服务等措施，并保留依法追究责任的权利。',
        ],
      },
      {
        heading: '五、户外安全与风险自担（重要免责）',
        body: [
          '本条款为重要免责条款，请你务必仔细阅读并充分理解。',
          '· 户外运动（徒步、越野跑等）具有固有风险，可能涉及地形复杂、天气突变、通讯中断、体力不支、迷路及其他不可预见的危险。你应对自身的健康状况、运动能力、装备准备及行程安全负全部责任。',
          '· 本应用提供的线路、导航、循迹、距离、爬升、海拔、天气等信息仅供参考，可能因数据来源、传感器精度、网络状况、地图更新滞后等原因存在误差或不完整，不构成任何形式的安全保证或行动建议。',
          '· 在户外环境中，卫星定位可能失准或无信号，后台记录与循迹功能可能受设备电量、系统限制等影响而中断。你不应将本应用作为唯一的导航或安全保障手段，应携带必要的备用导航工具与应急装备。',
          '· 你应在出行前评估自身能力与客观条件，遵守当地法律法规及保护区、景区的相关规定；遇险时应第一时间通过官方渠道寻求专业救援。',
          '· 在法律允许的最大范围内，对于你在户外活动中发生的人身伤害、财产损失或其他后果，我们不承担责任。你自愿承担户外活动的全部风险。',
        ],
      },
      {
        heading: '六、地图与第三方数据免责',
        body: [
          '· 本应用的底图、瓦片、地名、行政区划、海拔、天气及路网数据等来源于第三方服务（如 Mapbox、天地图、Apple 等），我们不对该等第三方数据的准确性、完整性、时效性作出保证。',
          '· 地图边界的标注以国家有关部门发布的官方标准地图为准。若你发现地图内容存在问题，欢迎向我们反馈。',
          '· 当你选择跳转至第三方地图或导航应用（如高德地图、百度地图等）时，相关行为将受该第三方应用的条款与政策约束，我们不对其服务负责。',
        ],
      },
      {
        heading: '七、知识产权',
        body: [
          '· 本应用及其相关软件、界面、图标、素材、文字、商标及其他构成要素的知识产权，除用户内容外，均归我们或相应权利人所有，受法律保护。',
          '· 未经我们书面许可，你不得对本应用进行复制、修改、反向工程、二次分发或用于商业目的。',
          '· 本条款未明确授予你的权利均由我们保留。',
        ],
      },
      {
        heading: '八、隐私与个人信息保护',
        body: [
          '· 我们高度重视你的个人信息与隐私保护。关于我们如何收集、使用、存储、共享和保护你的个人信息，以及你所享有的相关权利，请参阅与本条款配套的《寻径隐私政策》。',
          '· 《隐私政策》为本条款不可分割的组成部分。你使用本应用即表示你已阅读并理解该政策。',
        ],
      },
      {
        heading: '九、服务的变更、中断与终止',
        body: [
          '· 我们可能因业务调整、技术升级、维护、法律法规要求或不可抗力等原因，变更、暂停或终止全部或部分服务。对于重大变更，我们将以合理方式提前告知。',
          '· 你可以随时停止使用本应用。你可在设备上删除本地记录、关闭同步或卸载应用；也可在应用内「我的 → 编辑资料 → 删除账号」注销账号。账号资料、未发布私人草稿及独立上传的照片、视频和其他媒体随账号删除；仅已审核发布且许可与审批记录完整的线路目录数据（元数据、说明、轨迹几何与途经点，不含媒体）可去标识化保留，具体见《隐私政策》。',
          '· 若你严重违反本条款或法律法规，我们有权中止或终止向你提供服务。',
        ],
      },
      {
        heading: '十、免责声明与责任限制',
        body: [
          '· 本应用按「现状」和「现有」基础提供。在法律允许的范围内，我们不对服务的适销性、特定用途适用性及不中断、无错误作出明示或默示的保证。',
          '· 在法律允许的最大范围内，对于因使用或无法使用本应用所导致的间接、附带、特殊或后果性损失，我们不承担责任。',
          '· 因你违反本条款、违反法律法规或侵犯第三方权益而引起的任何索赔、损失或责任，由你自行承担；如因此给我们造成损失的，你应予赔偿。',
          '· 本条款中的免责与责任限制并不排除或限制依据法律不得排除或限制的责任。',
        ],
      },
      {
        heading: '十一、适用法律与争议解决',
        body: [
          '· 本条款的订立、生效、解释、履行及争议解决均适用中华人民共和国法律（不含港澳台地区法律）。',
          '· 因本条款或使用本应用产生的争议，双方应首先友好协商解决；协商不成的，依法向有管辖权的人民法院提起诉讼。',
        ],
      },
      {
        heading: '十二、其他与联系方式',
        body: [
          '· 我们可能不时更新本条款。更新后的条款经以合理方式公布后生效；如你继续使用本应用，即视为接受更新后的条款。',
          '· 若本条款的部分内容被认定为无效或不可执行，不影响其余条款的效力。',
          `· 运营者：归迹团队；联系邮箱：support@xingroute.com；网站 ICP 备案：${WEBSITE_ICP_FILING_NUMBER}；iOS APP 备案：${IOS_APP_FILING_NUMBER}。`,
        ],
      },
    ],
  },
  privacy: {
    title: '寻径 XingRoute 隐私政策',
    intro: [
      '本《隐私政策》（以下简称「本政策」）适用于寻径（XingRoute）iOS 应用程序及相关服务（以下简称「本应用」或「寻径」）。本应用由归迹团队（以下简称「我们」）开发与运营。',
      '生效日期：2026-08-24',
      '寻径是一款面向非铺装路面户外运动（徒步、越野跑）的轨迹记录与线路平台。我们主要面向中国大陆用户提供服务，服务器与业务数据均存储于中国境内。',
      '我们将依照《中华人民共和国个人信息保护法》《网络安全法》《数据安全法》等法律法规，保护你的个人信息安全。请你在使用本应用前仔细阅读并理解本政策，特别是以粗体或下划线标示的条款。你开始使用本应用，即表示你已充分理解并同意本政策。',
      '特别提示：本应用的核心功能依赖于你的精确位置与运动轨迹。默认情况下，你录制的轨迹、导入的文件仅保存在你的设备本地，不会自动上传至我们的服务器；只有在你主动开启 iCloud 同步、或主动执行「提名/发布线路」等操作时，相关数据才会离开本设备。你在路点拍摄或录制的照片、视频、音频始终仅保存在本设备，既不会随「提名/发布线路」上传，也不参与 iCloud 同步。',
    ],
    sections: [
      {
        heading: '一、我们如何收集和使用你的个人信息',
        body: [
          '我们仅在为实现本应用具体功能所必需的范围内，收集和使用你的个人信息。具体如下：',
          '（一）账号与身份信息',
          '· 当你使用「通过 Apple 登录」（Sign in with Apple）时，我们会通过 Apple 获取一个不可逆的 Apple 用户标识（identity token 中的 subject），用于建立并识别你的寻径账号。虽然登录流程会向 Apple 请求你的姓名与邮箱授权，但我们的后端仅使用该用户标识，不存储你的邮箱地址。',
          '· 在你首次授权时，Apple 可能返回你的姓名，我们会将其作为你的初始昵称；若未提供，我们会为你分配一个默认昵称。',
          '· 你可以设置公开的用户名（显示名，支持中文）和头像。头像照片会在你的设备本地降采样（不超过 512 像素、不超过 2MB）并重新编码后上传；由于是重新编码，通常不会保留原图中的拍摄位置、时间等元数据。用户名与头像属于公开信息，会在个人主页、协作记录、网页登录确认页等场景展示。',
          '· 为维持你的登录状态，本应用会在设备的钥匙串（Keychain）中保存短期访问令牌（默认约 15 分钟有效，仅限本机、不随 iCloud 钥匙串同步）；长效续期令牌以仅限本机的加密 Cookie 形式管理，我们服务器仅保存其哈希值、会话的创建/过期时间以及客户端设备信息（User-Agent，用于会话与安全管理），不保存明文令牌与 IP 地址。',
          '· 当你使用扫码授权网页端登录时，本应用会调用相机扫描二维码，仅解析其中的登录挑战信息用于确认网页登录，不保存图像，此过程不额外收集新的个人信息。',
          '· 本应用会在设备钥匙串中生成一个稳定的设备标识（随机 UUID）用于本地编辑归属，目前该标识不会上传至服务器。',
          '· 为保障账户与服务安全，我们的后端会记录与你账户相关的关键操作审计日志（如头像更新/删除、线路发布/归档、媒体上传等，包含你的用户标识、操作类型与时间），用于安全审计与问题排查。',
          '· 为保障服务可用性并排查故障，后端会记录请求时间、请求标识、接口路径、请求方法、响应状态、处理耗时，以及登录请求对应的用户标识；发生错误时还会记录错误类别与消息。结构化请求日志不记录请求正文、请求头、Cookie 或 IP 地址。',
          '（二）位置信息与运动轨迹（核心信息，特别说明）',
          '· 为在地图上显示你的位置、记录运动轨迹、浏览线路附近环境并沿已选线路循迹导航，本应用会在你授权后采集精确位置（GPS 经纬度）。我们仅申请「使用 App 期间」的定位权限；你可以在系统设置中关闭定位权限，关闭后当前位置显示、轨迹记录、循迹/导航及基于你当前位置的体验将受限，但仍可浏览公开线路与基础地图内容。',
          '· 每条轨迹的采样点可能包含：时间戳、经纬度、海拔、水平/垂直精度、速度与方向（航向）。',
          '· 当你处于录制或导航状态时，为在锁屏或切换后台时仍能连续记录轨迹，本应用会开启后台定位（系统会显示蓝色状态提示）。仅在你主动录制或导航时才会进行后台定位。',
          '· 为绘制你的朝向指示，录制/导航时会读取设备磁力计的航向数据（仅实时使用，不落盘）。',
          '· 你录制的轨迹默认仅以本地方式保存在设备中（不会自动上传服务器），直至你手动删除。',
          '（三）运动与健身（气压计）数据',
          '· 为获得更精准的海拔与爬升数据、并在会话面板展示相对海拔与气压，本应用会在录制时读取设备的气压计/运动数据。其中融合后的绝对海拔会随轨迹保存在本地，实时相对海拔与气压值仅用于展示、不持久保存。',
          '（四）相机、相册、麦克风与媒体信息',
          '· 在路点记录笔记时，你可以拍摄照片/视频、从相册选取照片/视频、或录制语音。这些媒体附件仅保存在你的设备沙盒本地目录中，不会随「提名/发布线路」上传；提名会上传 GPX 中的轨迹及途经点名称/备注，但不上传附件文件。',
          '· 当你为你创建/编辑的线路设置封面或配图时，相关图片会在你保存或发布时上传至我们的对象存储用于展示。请注意：已发布线路的封面/配图可被公开访问；若你通过网页端上传原始照片，其可能包含拍摄位置、时间等嵌入元数据，请自行注意脱敏。',
          '· 生成运动记录分享卡时，你从相册选取的照片仅在本机用于合成分享图片，不会上传至我们的服务器；合成后的图片经系统分享面板由你决定分享去向。',
          '（五）你主动上传/发布时的信息',
          '· 只有当你主动将某条本地录制或导入的轨迹提名为线路时，本应用才会上传 GPX。GPX 可能完整包含 track name（轨迹名称）、每个 track point 的坐标、海拔与时间戳，以及每个 waypoint 的坐标、海拔、时间戳、类型、符号、名称与备注。上传仅创建私人线路草稿；只有你另行完成发布许可确认且线路审核通过后，内容才进入公开线路目录。',
          '· 你收藏「云端」线路时，我们仅上传线路的标识（route_id）用于跨设备同步；你导入的本地轨迹文件（GPX/KML/KMZ）与运动记录不会因此上云。',
          '（六）我们不收集的信息',
          '· 除第三条披露的第三方地图/底图 SDK 或服务为提供地图服务可能处理或收集设备、使用情况与位置相关数据外，本应用未另行集成第三方统计、分析、广告或崩溃采集 SDK。查看「附近线路」时的排序在设备本地完成，不会向我们的服务器发送你的位置。',
          '· 本应用不会主动上报设备指纹用于用户画像或广告追踪。',
        ],
      },
      {
        heading: '二、设备权限的申请与用途',
        body: [
          '本应用会在你使用相应功能时，向系统申请以下权限。你可随时在系统「设置」中查看或撤回相关授权，撤回后可能影响对应功能的正常使用，但不影响撤回前基于授权进行的处理。',
          '· 定位（使用期间）：用于在地图上显示你的位置、记录轨迹、浏览线路附近环境及循迹导航；录制/导航时用于后台连续记录。你可以在系统设置中关闭定位权限，关闭后当前位置显示、轨迹记录、循迹/导航及基于你当前位置的体验将受限，但公开线路查看、搜索与基础地图浏览仍可使用。',
          '· 运动与健身：用于读取气压计数据以提升海拔与爬升的准确性。',
          '· 相机：用于拍摄线路照片/视频笔记，以及扫描网页登录二维码。',
          '· 麦克风：用于录制语音笔记。',
          '· 相册（照片）：用于选取照片/视频作为附件或分享卡背景。',
          '· 通知：用于在偏离线路等场景发送本地提醒。',
        ],
      },
      {
        heading: '三、我们如何共享、委托处理与第三方服务',
        body: [
          '为实现本应用的功能，部分数据会在必要范围内提供给以下第三方服务或基础设施提供方。我们建议你同时查阅相关第三方各自的隐私政策。',
          '· Apple（通过 Apple 登录）：用于账号登录，我们据此获取你的 Apple 用户标识。',
          '· Apple 天气（WeatherKit）：为向你展示天气，本应用会将设备提供的当前位置（可能为精确位置）发送给 Apple 获取天气；约 1 公里网格仅用于本地缓存键，结果在本机缓存约 20 分钟。',
          '· Apple 地图（MapKit 反向地理编码）：为识别位置对应的省/市名，本应用会将设备提供的当前位置（可能为精确位置）发送给 Apple 解析；约 1 公里网格仅用于本地缓存键。',
          '· Apple iCloud / CloudKit：仅在你开启同步时，用于跨设备同步你的运动记录与收藏/导入线路（详见第四条）。',
          '· 第三方地图/底图 SDK 通用说明：本 App 集成了 Mapbox SDK 和天地图 SDK/服务，用于展示地图底图、线路、路点、当前位置与当前轨迹，并提供线路浏览、循迹/导航及离线地图相关体验。加载地图、切换底图、缩放/平移地图或下载离线瓦片时，相关 SDK 或服务可能接收为提供地图服务所必需的网络请求信息（例如 IP 地址、设备与应用信息、请求时间、User-Agent）、地图样式/瓦片请求及其反映的浏览区域；当你授权定位并使用当前位置显示、当前轨迹展示、轨迹记录、线路浏览、循迹/导航等功能时，相关请求或 SDK 处理也可能涉及粗略或精确位置信息，具体取决于你的授权状态、所选底图和当时使用的功能。',
          '· Mapbox SDK：用于渲染地图底图、线路、当前位置与当前轨迹，并在你收藏线路或主动框选范围、选择样式下载离线地图时下载离线瓦片。它可能获取或处理你授予本 App 的定位信息，以便在地图上显示当前位置/当前轨迹、展示线路与提供地图服务；设备也会按当前地图视野、缩放级别与所选样式向 Mapbox 发起样式、字体、瓦片等请求。Mapbox SDK 还可能按其默认设置处理或收集设备、使用情况与位置相关数据。Mapbox 隐私政策：https://www.mapbox.com/legal/privacy',
          '· 天地图 SDK/服务（国家地理信息公共服务平台）：当你选择天地图作为底图时，用于展示天地图底图/注记、线路、当前位置与当前轨迹。它可能获取或处理你授予本 App 的定位信息，以便在地图上显示当前位置/当前轨迹、展示线路与提供地图服务；设备会向天地图官方服务请求相应区域的地图瓦片，这些请求可能反映你正在查看的地图区域。在线路富化时，我们的后端也可能将线路范围坐标发送给天地图，用于识别行政区与山峰名称。天地图隐私政策：https://map.tianditu.gov.cn/privacypolicy.html',
          '· 高德地图 / 百度地图 / Google 地图：仅当你主动选择跳转外部导航时，本应用会通过 URL 将某个位置点的坐标传递给你选择的第三方地图应用。',
          '· 阿里云（Alibaba Cloud）：作为我们的基础设施提供方，为我们在中国境内（杭州）托管服务器、数据库与对象存储，你主动上传的线路轨迹、头像、线路配图等存储于此。',
          '· 后端线路富化相关服务（在你主动提名/导入线路时触发）：为生成线路介绍、整理或翻译途经点文字、补全难度与地理信息，我们的后端可能将线路标题、统计信息、行政区名，以及（在含途经点导入时）途经点名称、说明与坐标发送给 AI 处理代理（部署于境外 Azure）；生成线路介绍时不发送原始逐点轨迹坐标。该自动链路不再查询 OpenStreetMap Overpass。涉及向境外传输的，我们将依法履行相应义务。',
          '· 网页端可选 AI 功能：当你在网页线路编辑器主动点击「AI 辅助」等明确标识的功能时，我们会将完成该次请求所必要的线路标题、描述、统计信息、行政区域、自然地貌与活动类型等发送给上述 AI 处理代理。',
          '· 网页端相关服务（仅在你使用网页端相应功能时）：路径规划预览会把你绘制的途经点坐标发送给 GraphHopper / BRouter（在未配置自建实例时可能回退到境外公共服务），网页端天气会把粗化坐标发送给和风天气（QWeather）。iOS 端的天气经 Apple WeatherKit 提供，不经上述网页端服务。',
          '除上述情形及法律法规要求或经你另行同意外，我们不会向其他第三方共享、转让你的个人信息。',
        ],
      },
      {
        heading: '四、iCloud 同步说明',
        body: [
          '· iCloud 同步为可选功能，默认关闭。只有当你在「我的 → 同步与备份」中主动开启后，你的运动记录与本地/收藏线路才会镜像到你本人 Apple 账号的 iCloud 私有数据库（容器 iCloud.com.xing.XingRoute），用于同一 Apple 账号下的跨设备同步与备份。',
          '· 同步范围仅包含运动记录与收藏/导入线路。地图缓存、应用偏好设置、以及照片/视频/音频等附件文件不在同步范围内。',
          '· 该同步经由 Apple iCloud/CloudKit 进行，不经过我们自有的服务器。据 Apple 公开信息，中国区 iCloud 由云上贵州（GCBD）运营、数据存储于中国境内；相关服务及其数据保留受 Apple iCloud/CloudKit 条款约束。',
          '· 删除语义：在已开启同步的设备上删除记录为「镜像删除」，会同步删除云端及其他已开启同步设备上的对应副本，且为最终一致、无撤销、无墓碑。关闭同步只停止同步、保留本地与云端已有副本；因此在长期离线后重新开启同步，个别已删除记录可能被重新上传而「复活」。',
        ],
      },
      {
        heading: '五、个人信息的存储地点与保留期限',
        body: [
          '· 存储地点：我们的后端服务、数据库（MongoDB）与对象存储（OSS）均部署在中国境内（阿里云杭州）。你的运动记录、导入文件与路点媒体默认仅存储在你的设备本地。',
          '· 保留期限：对于存储在我们服务器上的信息，我们在为实现本政策所述目的所必需的期间内予以保留；法律法规另有规定的，从其规定。',
          '· 本地信息将保留至你在设备上删除，或卸载应用（钥匙串中的部分标识可能因系统机制在重装后仍保留）。',
          '· 仅已审核发布且许可与审批记录完整的线路，其标题、摘要/说明、活动与难度等元数据、轨迹几何及途经点，可在公开目录所需期间内依据你提交时授予的长期、免费、非独占许可保留去标识化公开副本。该保留规则不适用于未发布私人草稿，也不适用于独立上传的照片、视频或其他媒体。',
          '· 为防灾备份，我们可能定期对服务器数据进行加密备份归档并存储于中国境内的对象存储，备份同样在必要期限内保留。',
        ],
      },
      {
        heading: '六、我们如何保护你的个人信息',
        body: [
          '· 我们采取合理的技术与管理措施保护你的个人信息，例如：登录令牌以仅限本机方式保存于设备钥匙串、续期令牌仅以哈希形式存储、传输采用 HTTPS 加密、密码（如涉及）以加盐哈希方式存储等。',
          '· 尽管我们努力保护，但请你理解，互联网环境并非绝对安全。请妥善保管你的设备与账号。',
          '· 若发生个人信息安全事件，我们将依照法律法规要求采取应急措施，并以适当方式告知你。',
        ],
      },
      {
        heading: '七、你的权利',
        body: [
          '在符合法律法规的前提下，你对自己的个人信息享有以下权利：',
          '· 查询与更正：你可以在应用内查看并修改你的昵称与头像；对于本地的运动记录与线路，你可随时查看、编辑与删除。',
          '· 删除：你可在设备上删除本地记录、附件与导入线路（本地删除为硬删除）；如已开启 iCloud 同步，删除会按第四条所述镜像至云端。对于已上传至服务器的线路、头像等数据，你可以删除或替换头像、删除单条媒体；如需删除其他服务器侧数据，请通过下方联系方式向我们提出。',
          '· 注销账号：你可在应用内「我的 → 编辑资料 → 删除账号」发起注销并进行二次确认。注销将删除与账号关联的个人信息、未发布私人线路草稿，以及你独立上传至服务器的照片、视频和其他媒体，并清理因此失效的封面引用；我们也会尽力撤销你的 Apple 登录授权。你本地设备上的运动记录与导入线路不随注销删除，可自行删除或通过卸载应用清理。',
          '· 关于你已发布的线路：仅对注销前已经审核发布且许可与审批记录完整的线路，平台可依据你提交发布审核时授予的长期、免费、非独占许可，保留标题、摘要/说明、活动与难度等元数据、轨迹几何及途经点的去标识化公开副本；该规则不适用于私人草稿，也不适用于独立上传的照片、视频和其他媒体。',
          '· 数据导出：目前暂未提供应用内的数据导出入口。如你希望获取个人信息副本，请通过 support@xingroute.com 与我们联系，我们将在核实身份后依法为你处理。',
          '· 撤回同意：你可随时在系统设置中撤回定位、相机、相册、麦克风、运动与健身等权限授权，或关闭 iCloud 同步。撤回不影响撤回前已进行的处理。',
          '我们将按照法律法规规定的方式与期限响应你的上述请求。',
        ],
      },
      {
        heading: '八、未成年人保护',
        body: [
          '· 本应用主要面向成年人。如你为未成年人，请在监护人的同意与指导下使用本应用。',
          '· 我们不会主动收集不满 14 周岁儿童的个人信息。若你为不满 14 周岁儿童的监护人，请在你同意并监护的前提下使用本应用相关功能。',
          '· 如我们发现在未取得监护人有效同意的情况下收集了不满 14 周岁儿童的个人信息，将设法尽快删除相关信息。监护人如对儿童个人信息有疑问，可通过下方方式与我们联系。',
        ],
      },
      {
        heading: '九、本地缓存与设备存储',
        body: [
          '· 为提升体验，本应用会在设备本地保存地图/离线瓦片缓存、路径缓存及应用偏好等。这些缓存可随时重建，且不参与 iCloud 同步。',
          '· 为在户外断网时可用，收藏线路时本应用可能按线路走廊范围向 Mapbox 预下载离线瓦片并存储于设备本地；取消收藏时会删除对应区域。当前不缓存天地图瓦片。',
          '· 你也可以在 iOS App 中主动框选范围并选择 Mapbox 底图样式下载离线地图，所选区域和样式会通过地图资源请求发送给 Mapbox。手动下载的区域独立于线路收藏，保存在本机，不参与 iCloud 同步，可在「离线地图」中暂停、继续或删除。下载可能使用蜂窝数据；共享资源及删除后的实际空间由 SDK 管理。',
        ],
      },
      {
        heading: '十、本政策的更新',
        body: [
          '· 我们可能不时更新本政策。发生重大变更时，我们将通过应用内提示、公告或其他合理方式通知你。',
          '· 更新后的政策经公布后生效。若你在更新后继续使用本应用，即表示你接受更新后的政策。',
        ],
      },
      {
        heading: '十一、如何联系我们',
        body: [
          '· 如你对本政策或个人信息处理有任何疑问、意见或投诉，或希望行使你的相关权利，可通过以下方式与我们联系：',
          '· 运营者：归迹团队',
          '· 联系邮箱：support@xingroute.com',
          `· 网站 ICP 备案：${WEBSITE_ICP_FILING_NUMBER}`,
          `· iOS APP 备案：${IOS_APP_FILING_NUMBER}`,
        ],
      },
    ],
  },
}
